export namespace TransactionConstants {
  export const TransactionForm = 'TransactionForm';
  export const TransactionFormFirstTime = 'TransactionFormFirstTime';
}
